import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-user-guest-list',
  templateUrl: './user-guest-list.component.html',
  styleUrls: ['./user-guest-list.component.scss'],
})
export class UserGuestListComponent implements OnInit {
  @Input() userGuestList: any;
  @Input() guestType: string;
  noData: boolean;
  public currentHeaderData: any = {
    modalSlotEnd : true,
    title : 'Select Guest',
    marl20 : true
  };

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.noData = false;
    if(this.guestType){
      this.userGuestList = this.userGuestList?.filter(
        (item) => item?.type?.toLowerCase() === this.guestType?.toLocaleLowerCase()
      );
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }

  selectGuest(item) {
    this.modalController.dismiss({
      ...item,
    });
  }
}
